import PendoCard from '../../components/card/pendo-card.vue.js';
import PendoRadioGroup from '../../components/radio-group/pendo-radio-group.vue.js';
import PendoRadio from '../../components/radio/pendo-radio.vue.js';
import PendoTooltip from '../../directives/tooltip/tooltip.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoFormItem from '../../components/form/pendo-form-item.vue.js';
import PendoForm from '../../components/form/pendo-form.vue.js';
import PendoCheckboxGroup from '../../components/checkbox-group/pendo-checkbox-group.vue.js';
import PendoCheckbox from '../../components/checkbox/pendo-checkbox.vue.js';
import PendoAlert from '../../components/alert/pendo-alert.vue.js';
import PendoCopyCodeBlock from '../copy-code-block/pendo-copy-code-block.vue.js';
import PendoKeyRotation from '../key-rotation/pendo-key-rotation.vue.js';
import { getSnippets, SNIPPET_APP_TYPES, adoptJWTSnippet, engageJWTSnippet } from './snippet-code.js';
import get from 'lodash/get.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'PendoInstallSettings',
  components: {
    PendoKeyRotation,
    PendoCard,
    PendoRadioGroup,
    PendoRadio,
    PendoButton,
    PendoCopyCodeBlock,
    PendoModal,
    PendoInput,
    PendoFormItem,
    PendoForm,
    PendoCheckboxGroup,
    PendoCheckbox,
    PendoAlert
  },
  directives: {
    PendoTooltip
  },
  props: {
    app: {
      type: Object,
      required: true
    },
    keys: {
      type: Array,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    isMobileApp: {
      type: Boolean,
      required: true
    },
    hasAllowSignedMetadataFlag: {
      type: Boolean,
      required: true
    },
    hasAccounts: {
      type: Boolean,
      default: true
    },
    hasParentAccounts: {
      type: Boolean,
      required: true
    },
    sharedTokensLoading: {
      type: Boolean,
      required: true
    },
    host: {
      type: String,
      required: true
    },
    loadingSelections: {
      type: Object,
      required: true
    },
    disableJwtEnableButton: {
      type: Boolean,
      required: true
    },
    enableSignedMetadataFlag: {
      type: Boolean,
      required: true
    },
    requireSignedMetadataFlag: {
      type: Boolean,
      required: true
    },
    isAdopt: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const appTypeOptions = [{
      value: SNIPPET_APP_TYPES.MULTI_PAGE_APP,
      label: 'Multi-Page App'
    }, {
      value: SNIPPET_APP_TYPES.SINGLE_PAGE_APP,
      label: 'Single-Page App'
    }];
    const jwtConfirmModalVals = {
      jwtProcessingVal: 'confirmJwtProcessing',
      jwtReprocessingVal: 'confirmCannotReprocess',
      jwtKeyRevokedVal: 'confirmRevokeKeys',
      jwtEventsVal: 'confirmJwtNotProcessEvents'
    };
    return {
      appTypeOptions,
      installTipsActionButtons: [{
        label: 'Done',
        theme: 'app',
        handler: this.hideInstallTipsModal
      }],
      installTipsModalVisible: false,
      isJwtConfirmModalVisible: false,
      modalForm: {
        confirmText: ''
      },
      callValidate: false,
      rules: {
        confirmText: [{
          validator: this.validateConfirmText,
          trigger: 'blur'
        }]
      },
      confirmModalType: null,
      jwtCheckboxOptions: {
        disableJwt: [{
          value: jwtConfirmModalVals.jwtKeyRevokedVal,
          label: 'All active JWT keys will be revoked'
        }, {
          value: jwtConfirmModalVals.jwtEventsVal,
          label: 'Events with signed metadata will not be processed'
        }],
        requireJwt: [{
          value: jwtConfirmModalVals.jwtProcessingVal,
          label: 'Pendo will stop processing any events without signed metadata'
        }, {
          value: jwtConfirmModalVals.jwtReprocessingVal,
          label: 'Data cannot be reprocessed'
        }]
      },
      jwtConfirmationCheckboxes: [],
      callResetFields: false
    };
  },
  computed: {
    isFramework() {
      return get(this.app, 'framework', '');
    },
    minSdkVersion() {
      return this.isFramework ? '2.16' : '2.13';
    },
    snippets() {
      return getSnippets({
        apiKey: this.app.apiKey,
        host: this.host,
        isJwtEnabled: this.enableSignedMetadataFlag,
        hasAccounts: this.hasAccounts,
        hasParentAccounts: this.hasParentAccounts,
        appType: this.appType,
        isAdopt: this.isAdopt
      });
    },
    activeKeys() {
      if (!this.keys) {
        return [];
      }
      return this.keys.filter(key => !key.revoked);
    },
    appType() {
      return get(this.app.applicationFlags, 'isSinglePage', false) ? SNIPPET_APP_TYPES.SINGLE_PAGE_APP : SNIPPET_APP_TYPES.MULTI_PAGE_APP;
    },
    keyIdPrefix() {
      const subPrefix = this.subscription.displayName.replace(/ /g, '_').substring(0, 4).toLowerCase();
      const appPrefix = this.app.displayName.replace(/ /g, '_').substring(0, 4).toLowerCase();
      return `${subPrefix}-${appPrefix}`;
    },
    modalButtonText() {
      switch (this.confirmModalType) {
        case 'requireJwt':
          return 'Enable Signed Metadata';
        case 'disableJwt':
          return 'Disable Signed Metadata';
        default:
          return 'Confirm';
      }
    },
    checkJwtConfirmCheckBoxes() {
      const relevantOptionLabels = this.jwtCheckboxOptions[this.confirmModalType].map(_ref => {
        let {
          label
        } = _ref;
        return label;
      });
      const confirmations = relevantOptionLabels.every(label => this.jwtConfirmationCheckboxes.includes(label));
      const mobileOnly = this.jwtConfirmationCheckboxes.includes(this.mobileJwtOnlyCheckBox.label);
      if (this.isMobileApp && this.confirmModalType === 'requireJwt') {
        return confirmations && mobileOnly;
      }
      return confirmations;
    },
    disableSubmit() {
      return this.modalForm.confirmText !== 'I understand' || !this.checkJwtConfirmCheckBoxes;
    },
    jwtWarningMessage() {
      return this.confirmModalType === 'requireJwt' ? 'Pendo will not be able to ingest data until a valid JWT key has been added' : 'All currently active JWT keys will be revoked and events with signed metadata will not be processed until a new key is installed.';
    },
    getModalButtonType() {
      return this.confirmModalType === 'disableJwt' ? 'danger' : 'primary';
    },
    step1Title() {
      return this.isMobileApp ? '(Optional) Customize your SDK' : 'Step 1: Customize your snippet';
    },
    mobileJwtOnlyCheckBox() {
      return {
        value: 'confirmMobileSdk',
        label: `Events coming in form app versions with SDK lower than ${this.minSdkVersion}
                will be ignored by Pendo.`
      };
    },
    signedMetadataCodeSnippet() {
      return this.isAdopt ? adoptJWTSnippet({
        hasAccounts: this.hasAccounts,
        hasParentAccounts: this.hasParentAccounts
      }) : engageJWTSnippet({
        hasAccounts: this.hasAccounts,
        hasParentAccounts: this.hasParentAccounts
      });
    }
  },
  watch: {
    loadingSelections: {
      handler() {
        if (this.isJwtConfirmModalVisible && !this.loadingSelections.jwtModal) {
          this.closeJwtConfirmModal();
        }
      },
      deep: true
    }
  },
  created: _async(function () {
    const _this = this;
    if (_this.isMobileApp) {
      _this.jwtCheckboxOptions.requireJwt.push(_this.mobileJwtOnlyCheckBox);
    }
    return _await();
  }),
  methods: {
    updateAppFlag(options) {
      this.$emit('updateAppFlag', options);
    },
    submitModal: _async(function () {
      const _this2 = this;
      const isRequireJwtModal = _this2.confirmModalType === 'requireJwt';
      _this2.handleFlagChange({
        enabled: isRequireJwtModal,
        flag: isRequireJwtModal ? 'requireSignedMetadata' : 'enableSignedMetadata'
      }, 'jwtModal');
      return _await();
    }),
    onAppTypeChange(appType) {
      this.updateAppFlag({
        appOptions: {
          appId: this.app.id,
          flag: 'isSinglePage',
          enabled: appType === SNIPPET_APP_TYPES.SINGLE_PAGE_APP
        },
        loading: {
          type: 'appType'
        }
      });
    },
    handleFlagChange(_ref2, buttonLoadingState) {
      let {
        enabled,
        flag
      } = _ref2;
      this.updateAppFlag({
        appOptions: {
          appId: this.app.id,
          flag,
          enabled
        },
        loading: {
          type: buttonLoadingState
        }
      });
    },
    disableJwt() {
      this.confirmModalType = 'disableJwt';
      this.isJwtConfirmModalVisible = true;
      this.callResetFields = true;
    },
    enableRequireJwt() {
      this.confirmModalType = 'requireJwt';
      this.isJwtConfirmModalVisible = true;
      this.callResetFields = true;
    },
    showInstallTipsModal() {
      this.installTipsModalVisible = true;
    },
    hideInstallTipsModal() {
      this.installTipsModalVisible = false;
    },
    closeJwtConfirmModal() {
      this.eventJwtValue = false;
      this.isJwtConfirmModalVisible = false;
      this.jwtConfirmationCheckboxes = [];
      this.modalForm.confirmText = '';
    },
    validateConfirmText(rule, val, cb) {
      if (val !== 'I understand') {
        cb(new Error('Confirmation text must match'));
      } else {
        cb();
      }
    },
    getToolTipConfig(_ref3) {
      let {
        content
      } = _ref3;
      return {
        placement: 'top',
        boundariesElement: 'viewport',
        arrow: false,
        trigger: 'hover',
        multiline: true,
        content
      };
    },
    handleSharedTokenStateChange(method, options) {
      this.$emit(method, options);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-install-settings.vue2.js.map
